<template>
  <div class="mb10" style="position:relative">
    <div :class="[animation ? 'transition' : 'transition1', 'project-step-cover']"></div>
    <p class="bottom-line dialog-title">
      {{ (radishProject && radishProject['radish'] && radishProject['radish']['姓名']) || '未选择' }}
    </p>
    <div class="mb10" style="display:flex">
      <el-button
        v-if="radishProject.状态 && (radishProject.状态.detail == '淘汰' || radishProject.状态.detail == '放弃')"
        class="mb10"
        type="primary"
        size="mini"
        @click="reStart"
        >重启人选</el-button
      >
      <template v-else>
        <el-button class="mr10" type="primary" size="mini" @click="showInterview">安排下一轮面试</el-button>
        <el-button type="primary" size="mini" @click="showOfferMaybe">拟offer</el-button>
      </template>
    </div>
    <p class="bottom-line dialog-title">面试反馈</p>
    <div>
      <div class="rpg-bd rpg-pd-5-10">
        <div class="rpg-tag-blue">人选对职位的反馈</div>
        <div class="rpg-pd-5">
          <label>人选意愿：</label><br />
          <el-radio v-model="yiyuan" label="非常积极">非常积极</el-radio>
          <el-radio v-model="yiyuan" label="积极">积极</el-radio>
          <el-radio v-model="yiyuan" label="犹豫">犹豫需要推动</el-radio>
          <el-radio v-model="yiyuan" label="放弃">人选放弃</el-radio>
        </div>
        <div class="rpg-pd-5">
          <div>
            <span>反馈问题：</span> <span class="rpg-btn rpg-btn-outline" @click="showTmp">点击按照模板填写</span>
          </div>
          <el-input
            v-model="radishFeedback"
            type="textarea"
            rows="3"
            placeholder="填写人选面试反馈：见了谁、多长时间、沟通情况、问了那些问题、意向如何、有什么诉求等反馈信息；人选风险点以及给客户的建议（也可按照模板填写）"
          ></el-input>
          <!-- <el-checkbox v-model="sendWxRadish">发送微信消息通知客户经理</el-checkbox> -->
        </div>
        <div class="rpg-pd-5-10"></div>
        <div class="rpg-pd-5 rpg-text-right">
          <el-button size="mini" type="primary" @click="handleConfirmRadish">提交反馈</el-button>
        </div>
      </div>
      <div class="rpg-bd rpg-pd-5-10 rpg-mgb-5">
        <div class="rpg-tag-blue">客户对候选人面试反馈</div>
        <div class="rpg-pd-5">
          <label>面试结果：</label><br />
          <el-radio v-model="result" label="合适">合适</el-radio>
          <el-radio v-model="result" label="淘汰">不合适（人选淘汰）</el-radio>
          <el-radio v-model="result" label="待定">待定</el-radio>
        </div>
        <div class="rpg-pd-5">
          <div>反馈问题：</div>
          <el-input
            v-model="clientFeedback"
            type="textarea"
            rows="3"
            placeholder="填写客户&客户经理对于人选的反馈以及疑问；"
          ></el-input>
          <!-- <el-checkbox v-model="sendWxClient">发送微信消息通知顾问</el-checkbox> -->
        </div>
        <div class="rpg-pd-5 rpg-text-right">
          <el-button size="mini" type="primary" @click="handleConfirmClient">提交反馈</el-button>
        </div>
      </div>
    </div>
    <div class="rpg-pd-5 rpg-bd-t">
      <div v-for="(feed, k) in feedbacks" :key="k">
        <div>
          <span class="rpg-gray rpg-mgr-5">{{ feed.时间 }}&nbsp;&nbsp;--{{ feed.顾问 }}</span>
          <span class="rpg-tag-gray-sm">{{ feed.类型 }}</span>
        </div>
        <div>
          <pre class="rpg-pre"><i class="el-icon-warning"></i>{{ feed.内容 }}</pre>
        </div>
      </div>
    </div>
    <!-- components -->
    <ProgressDia ref="ProgressDia" :on-confirm="loadData"></ProgressDia>
    <el-dialog
      title="人选面试反馈模板填写"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="60px"
      :modal="false"
      class="rpg-dialog"
    >
      <div>
        <el-form :model="formData" label-width="130px" size="mini">
          <el-form-item label="候选人:">
            <span>{{ formData.候选人 }}</span>
          </el-form-item>
          <el-form-item label="推荐顾问:">
            <span>{{ formData.推荐顾问 }}</span>
          </el-form-item>
          <el-form-item label="面试时间:">
            <span>{{ formData.面试时间 }}</span>
          </el-form-item>
          <el-form-item label="面试官:"> <el-input v-model="formData.面试官"></el-input> </el-form-item>
          <el-form-item label="面试时长:">
            <el-input v-model="formData.面试时长" placeholder="总体的面试时间"></el-input>
          </el-form-item>
          <el-form-item label="面试内容:">
            <el-input
              v-model="formData.沟通情况"
              type="textarea"
              placeholder="问了哪些问题，如何回答的？整体面试感觉如何？有哪些疑问？等面试情况，以便于把握人选"
            ></el-input>
          </el-form-item>
          <el-form-item label="人选意向:">
            <el-radio v-model="yiyuan" label="非常积极">非常积极</el-radio>
            <el-radio v-model="yiyuan" label="积极">积极</el-radio>
            <el-radio v-model="yiyuan" label="犹豫">犹豫需要推动</el-radio>
            <el-radio v-model="yiyuan" label="放弃">人选放弃</el-radio>
          </el-form-item>
          <el-form-item label="人选诉求:">
            <el-input v-model="formData.人选诉求" placeholder="面试之后人选诉求如何"></el-input>
          </el-form-item>
          <el-form-item label="人选动因:">
            <el-input v-model="formData.人选动因" placeholder="人选动因"></el-input>
          </el-form-item>
          <el-form-item label="人选目前薪酬:">
            <el-input v-model="formData.人选目前薪酬" placeholder="人选现在的薪酬情况"></el-input>
          </el-form-item>
          <el-form-item label="人选目前职级:">
            <el-input v-model="formData.人选目前职级" placeholder="人选现在的职级情况"></el-input>
          </el-form-item>
          <el-form-item label="离职周期:">
            <el-input v-model="formData.离职周期" placeholder="人选离职周期"></el-input>
          </el-form-item>
          <el-form-item label="预计到岗时间:">
            <el-input v-model="formData.预计到岗时间" placeholder="人选预计到岗时间"></el-input>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item>
            <template slot="label">
              风险点:
              <el-popover v-model="fengVisible" placement="left" trigger="click" width="320">
                1、人选是否有竞业禁止？<br />
                2、家人是否同意？<br />
                3、人选是否有项目或者其他工作如果离开，公司会不同意。<br />
                4、我们是否做了他的背景调查（口碑评价），如果客户录用前背景调查是否会通不过？
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </template>
            <el-input
              v-model="formData.风险点"
              placeholder="人选可能存在的风险点"
              @focus="fengVisible = true"
            ></el-input>
          </el-form-item>
          <el-form-item label="人选目前其他offer:">
            <el-input v-model="formData.人选目前其他offer" placeholder="人选目前其他offer"></el-input>
          </el-form-item>
          <el-form-item label="推进建议:">
            <el-input v-model="formData.推进建议" placeholder="给到客户&客户经理的建议"></el-input>
          </el-form-item>
          <el-form-item> <el-button type="primary" @click="confirmTemplate">提交反馈</el-button> </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ProgressDia from '../../../../radish/src/progress/progress-dia'
import projectNotify from '../../../../radish/src/constant/project_notify'

const dateFormat = require('dateformat')

export default {
  components: { ProgressDia },
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
    radishProject: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      temp: {},
      user: '',
      animation: false,
      result: '合适',
      yiyuan: '非常积极',
      clientFeedback: '',
      radishFeedback: '',
      sendWxClient: false,
      sendWxRadish: false,
      rid: '',
      pid: '',
      feedbacks: [],
      interview: {},
      formData: {},
      fengVisible: false,
      dialogVisible: false,
    }
  },
  computed: {
    isCustomerManager() {
      const manger = this.project.客户开发 || []
      return manger.includes(app.user.account)
    },
  },
  watch: {
    radishProject: {
      async handler (newValue, oldValue) {
        this.rid = this.radishProject.rid
        this.pid = this.radishProject.pid
        if (newValue && newValue._id && this.pid === this.project._id) {
          const res = await app.service('radish').findInterview({ rid: this.rid, pid: this.pid })
          if (res.status == 'success') {
            if (res.data.length > 0) {
              this.interview = res.data[0]
              if (res.data[0].面试反馈) {
                this.setFeedbacks(res.data[0].面试反馈)
              }
              this.clientFeedback = ''
              this.radishFeedback = ''
              this.result = '合适'
              this.yiyuan = '非常积极'
              this.sendWxClient = false
              this.sendWxRadish = false
              this.formData = {
                候选人: this.interview.候选人,
                推荐顾问: this.interview.顾问,
                面试时间: this.interview.面试时间,
                面试官: this.interview.面试官,
              }
            } else {
              this.$message.error('未找到对应面试数据')
            }
          } else {
            this.$message.error(res.msg)
          }
          this.animation = !this.animation
        }
      },
      immediate: true,
    },
  },
  methods: {
    async handleConfirmClient() {
      const dt = {
        结果: this.result,
        客户经理反馈: this.clientFeedback,
        sendWx: this.sendWxClient,
      }
      const res = await app.service('radish').addFeedback({ _id: this.interview._id, data: dt, type: 'interview' })
      if (res.status == 'success') {
        this.setFeedbacks(res.data.面试反馈)
        this.clientFeedback = ''
        this.result = '合适'
        // this.sendWxClient = true
        // this.onConfirm()
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    async handleConfirmRadish() {
      const dt = {
        人选意愿: this.yiyuan,
        候选人反馈: this.radishFeedback,
        sendWx: this.sendWxRadish,
      }
      const res = await app.service('radish').addFeedback({ _id: this.interview._id, data: dt, type: 'interview' })
      if (res.status == 'success') {
        this.setFeedbacks(res.data.面试反馈)
        this.radishFeedback = ''
        this.yiyuan = '非常积极'
        // this.sendWxRadish = true
        // this.onConfirm()
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    showTmp() {
      this.dialogVisible = true
    },
    confirmTemplate() {
      const textArr = []
      if (this.formData.人选意向) textArr.push(`意向：${this.yiyuan}`)
      if (this.formData.沟通情况) textArr.push(`面试内容：\n${this.formData.沟通情况}`)
      if (this.formData.人选动因 || this.formData.人选诉求)
        textArr.push(
          `人选动因： ${this.formData.人选动因 ? `\n动因：${  this.formData.人选动因}` : ''} ${
            this.formData.人选诉求 ? `\n诉求：${  this.formData.人选诉求}` : ''
          }`,
        )
      if (this.formData.人选目前薪酬 || this.formData.人选目前职级)
        textArr.push(`目前薪酬： ${this.formData.人选目前薪酬 || ''} ${this.formData.人选目前职级 || ''}`)
      if (this.formData.风险点 || this.formData.人选目前其他offer)
        textArr.push(
          `潜在的风险点： ${this.formData.风险点 ? `\n${  this.formData.风险点}` : ''} ${
            this.formData.人选目前其他offer ? `\n人选目前其他offer：${  this.formData.人选目前其他offer}` : ''
          }`,
        )
      if (this.formData.推进建议) textArr.push(`建议：\n${this.formData.推进建议}`)
      if (this.formData.离职周期 || this.formData.预计到岗时间)
        textArr.push(
          `其他： ${this.formData.离职周期 ? `\n离职周期：${  this.formData.离职周期}` : ''} ${
            this.formData.预计到岗时间 ? `\n预计到岗时间：${  this.formData.预计到岗时间}` : ''
          }`,
        )

      const text = textArr.reduce((total, currentValue, currentIndex) => `${total + (currentIndex + 1)  }、${  currentValue  }\n\n`, '')
      // const obj = JSON.parse(JSON.stringify(this.formData))
      // this.feedbackObj = obj
      this.radishFeedback = text
      this.formData = {}
      this.handleConfirmRadish()
    },
    setFeedbacks(feedbacks) {
      this.feedbacks = feedbacks
        .map(f => {
          f.时间 = dateFormat(f.时间, 'yyyy-mm-dd HH:MM')
          return f
        })
        .sort((a, b) => (a.时间 < b.时间 ? 1 : -1))
    },
    // confirmTemplate({ text, obj }) {
    //   this.$set(this.temp, '候选人反馈', text)
    //   this.save()
    // },
    // getInterview() {
    //   if (this.interview) this.clearTemp()
    //   const interviews = this.project.interviews
    //   interviews.sort((a, b) => b.createdAt - a.createdAt)
    //   const interview = interviews.find(val => val.rid === this.radishProject.rid)
    //   this.interview = interview
    // },
    // clearTemp() {
    //   const fields = ['结果', '客户经理反馈', '候选人反馈']
    //   fields.forEach(field => {
    //     this.$set(this.temp, field, null)
    //   })
    // },
    // getStorage() {
    //   const storage = localStorage.getItem('interviewHistory')
    //   const obj = (storage && JSON.parse(storage)) || {}

    //   this.interviewHistory = obj
    // },
    // updateStorage({ _id, arr }) {
    //   // const badgeFields = ['客户经理人选反馈','客户对项目反馈']
    //   const storage = localStorage.getItem('interviewHistory')
    //   let obj = {}
    //   try {
    //     obj = (storage && JSON.parse(storage)) || {}
    //   } catch (e) {
    //     console.log(e)
    //   }
    //   arr.forEach(v => {
    //     delete v.badge
    //   })
    //   obj[_id] = arr
    //   localStorage.setItem('interviewHistory', JSON.stringify(obj))
    // },
    // getFeedBack() {
    //   this.getStorage()
    //   const { interviewHistory } = this
    //   const account = app.user.account

    //   const interviews = this.project.interviews.filter(val => val.rid === this.radishProject.rid)
    //   const feedbacks = []
    //   interviews.forEach(val => {
    //     if (val.面试反馈) feedbacks.push(...val.面试反馈)
    //   })
    //   feedbacks.sort((a, b) => a.时间 - b.时间)
    //   this.managerFeedbacks = feedbacks.filter(v => v.类型 === '客户经理')
    //   this.radishFeedbacks = feedbacks.filter(v => v.类型 === '候选人')

    //   const arr = interviewHistory[`${this.radishProject.pid}${this.radishProject.rid}`] || []
    //   let updateStorageFlag = false
    //   this.managerFeedbacks.forEach(val => {
    //     // 查找填写数据的是当前用户，或者历史查记录中是否包含此条数据的，如果找到，说明不用显示红点
    //     const a = val.user === account || arr.find(v => JSON.stringify(v) === JSON.stringify(val))
    //     this.$set(val, 'badge', !a)
    //     if (!a) updateStorageFlag = true
    //   })
    //   this.radishFeedbacks.forEach(val => {
    //     // 查找填写数据的是当前用户，或者历史查记录中是否包含此条数据的，如果找到，说明不用显示红点
    //     const a = val.user === account || arr.find(v => JSON.stringify(v) === JSON.stringify(val))
    //     this.$set(val, 'badge', !a)
    //     if (!a) updateStorageFlag = true
    //   })
    //   if (updateStorageFlag)
    //     this.updateStorage({ _id: `${this.radishProject.pid}${this.radishProject.rid}`, arr: feedbacks })
    // },
    // async save() {
    //   if (!this.interview) return this.$message.error('请选择候选人')

    //   // const data = []
    //   // if (this.temp.客户经理反馈) data.push({ 类型: '客户', 内容: this.temp.客户经理反馈, 结果: this.temp.结果 })
    //   // if (this.temp.候选人反馈) data.push({ 类型: '候选人', 内容: this.temp.候选人反馈, 结果: this.temp.结果 })

    //   // if (data.length === 0) return this.$message.error('请填写反馈内容')

    //   // const res = await app.service('radish').addInterviewFeedBack({ feedbacks: data, id: this.interview._id })
    //   const res = await app
    //     .service('radish')
    //     .addFeedback({ _id: this.interview._id, data: this.temp, type: 'interview' })
    //   if (res.status === 'success') {
    //     await this.findInterview()
    //     // Object.assign(this.interview, { 推荐反馈: res.data.推荐反馈 })
    //     const tempFeedback2radish = this.temp.客户经理反馈
    //     const tempRadishFeedback = this.temp.候选人反馈
    //     this.clearTemp()
    //     this.getFeedBack()
    //     // this.$emit('reloadProject', this.project)
    //     this.$message.success('保存成功')

    //     const tmp = await app.service('radish').findInterview({ rid: this.interview.rid, pid: this.interview.pid })
    //     const 推荐人 = tmp && tmp.data && tmp.data[0] && tmp.data[0].顾问
    //     if (推荐人) {
    //       // throw new Error("推荐人 is null",tmp)
    //       const recevier = [推荐人]
    //       projectNotify.sendMessage(
    //         this.interview.rid,
    //         this.interview.pid,
    //         '-面试反馈',
    //         '面试反馈4',
    //         { 客户对人选反馈: tempFeedback2radish },
    //         recevier,
    //       )
    //       projectNotify.sendMessage(this.interview.rid, this.interview.pid, '-面试反馈', '面试反馈5', {
    //         候选人反馈: tempRadishFeedback,
    //       })
    //     }
    //   } else this.$message.error(res.msg)
    // },
    // async findInterview() {
    //   if (!this.interview) return
    //   const res = await app.service('radish').findInterview({ rid: this.interview.rid, pid: this.interview.pid })
    //   if (res.status === 'success') {
    //     if (res.data.length > 0) {
    //       Object.assign(this.interview, res.data[0])
    //     } else {
    //       this.$message.error('未找到对应推荐数据')
    //     }
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    // },
    showInterview() {
      if (!this.radishProject._id) return this.$message.error('请先选择人选')
      this.$refs.ProgressDia.open({ radish: this.radishProject.radish, project: this.project, compName: 'InterviewCreate' })
    },
    showOfferMaybe() {
      if (!this.radishProject._id) return this.$message.error('请先选择人选')
      this.$refs.ProgressDia.open({ radish: this.radishProject.radish, project: this.project, compName: 'OfferMaybe' })
    },
    confirmOffer() {
      this.$emit('removeInterview', this.radishProject)
      this.$emit('reloadProject', this.project)
    },
    loadData() {
      this.$emit('reloadProject', this.project)
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },

    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}` : ''
    },
    reStart() {
      this.$confirm('确定要重启人选吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          // 重启
          await app.service('radish').reStartProgress({ rid: this.radishProject.rid, pid: this.project._id })
          this.loadData()
        }).catch(() => {
        });
    },
  },
}
</script>
<style scoped>
.bolder {
  font-weight: 700;
}
.project-step-cover {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: #fff;
  opacity: 0;
}
.project-step-cover.transition {
  animation: totransprant 0.5s forwards;
}
.project-step-cover.transition1 {
  animation: totransprant1 0.5s forwards;
}
@keyframes totransprant {
  0% {
    z-index: 1;
    opacity: 1;
  }
  100% {
    opacity: 0;
    z-index: -1;
  }
}
@keyframes totransprant1 {
  0% {
    z-index: 1;
    opacity: 1;
  }
  100% {
    opacity: 0;
    z-index: -1;
  }
}
.bottom-line:after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #c5c5c5;
  margin-top: 5px;
  margin-bottom: 10px;
}
.textarea-btn-box {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #4a4848;
}
.badge-dot {
  height: 8px;
  width: 8px;
  padding: 0;
  right: 0;
  border-radius: 50%;
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
}
</style>
